export enum UserRole {
    Admin = "admin",
}
